import { create } from "zustand";
import { fetchTotalUnreadNotifications } from "@/hooks/services/workchestra/handler/notifications-api";

interface NotificationState {
  unreadCount: number;
  fetched: boolean;
  setUnreadCount: (count: number) => void;
  decrementUnreadCount: () => void;
  resetUnreadCount: () => void;
  initUnreadCount: () => Promise<void>;
}

// Module-level promise guard prevents concurrent duplicate requests
let fetchPromise: Promise<void> | null = null;

export const useNotificationStore = create<NotificationState>((set, get) => ({
  unreadCount: 0,
  fetched: false,
  setUnreadCount: (count) => set({ unreadCount: count }),
  decrementUnreadCount: () =>
    set((state) => ({ unreadCount: Math.max(0, state.unreadCount - 1) })),
  resetUnreadCount: () => set({ unreadCount: 0 }),
  initUnreadCount: () => {
    if (get().fetched) return Promise.resolve();
    if (fetchPromise) return fetchPromise;
    fetchPromise = fetchTotalUnreadNotifications()
      .then((res) => {
        set({ unreadCount: res.totalUnread, fetched: true });
      })
      .catch(() => {
        fetchPromise = null; // allow retry on next call if request failed
      });
    return fetchPromise;
  },
}));
